import React, { useState } from "react"
import { mutationRequest } from "../../util/request"
import { CollaboratorEntry } from "../../types/events"

interface CollaborationInviteHeaderProps {
  postId: number
  collaborator: CollaboratorEntry
  onAccepted: () => void
  onDeclined: () => void
}

const CollaborationInviteHeader: React.FC<CollaborationInviteHeaderProps> = ({
  postId,
  collaborator,
  onAccepted,
  onDeclined,
}) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const respond = async (status: "accepted" | "declined") => {
    setLoading(true)
    setError(null)
    try {
      const result = await mutationRequest({
        path: `/api/v1/posts/${postId}/post_collaborations/${collaborator.id}`,
        options: { method: "PUT" },
        data: { status },
      })
      if (result.success) {
        status === "accepted" ? onAccepted() : onDeclined()
      } else {
        setError(result.errors?.error || "Something went wrong")
      }
    } catch (e) {
      setError("Something went wrong")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="bg-blue-600 flex items-center text-white mb-2 gap-3 px-2 py-1 text-sm">
      <span>You&apos;ve been invited to collaborate on this event.</span>
      <button
        disabled={loading}
        onClick={() => respond("accepted")}
        className="bg-white text-blue-700 font-semibold px-2 py-0.5 rounded hover:bg-blue-50 disabled:opacity-50"
      >
        Accept
      </button>
      <button
        disabled={loading}
        onClick={() => respond("declined")}
        className="text-blue-200 underline hover:text-white disabled:opacity-50"
      >
        Decline
      </button>
      {error && <span className="text-red-300 text-xs">{error}</span>}
    </div>
  )
}

export default CollaborationInviteHeader
